window.Popper = require('popper.js').default;

try {
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
  require('bootstrap-datepicker');
  require('select2');

  window.bsCustomFileInput = require('bs-custom-file-input');
} catch (e) {}

$(document).ready( function() {
  bsCustomFileInput.init();

	$("#from_date,#to_date").datepicker({
		autoclose: true,
		format: "mm/dd/yyyy"
	});

	$('.datepicker-group i').on('click', function(){
		$(this).closest('.datepicker-group').find('.form-control').select();
	});

	// Select2
	$('#visibilities').select2({
		tags: "true",
		placeholder: 'Select site'
	});
});
